<template>
  <footer>
    <div class="link">
        <div class="linkContent">
            <div class="linkTitle" >
                友情链接
                <div></div>
            </div>
            <div>
                <a href="https://imi.fudan.edu.cn/info/1504/1135.htm"><span>复旦大学智能医学研究院</span></a>
                <a style="height: 42px"><span>中国研究型医院学会<br>临床数据与样本资源库专业委员会</span></a>
                <a ><span>临床数据与样本资源应急服务平台</span></a>
<!--                <a  class="wow bounceInLeft" data-wow-duration="2s"><span>生物谷</span></a>-->
            </div>
        </div>
        <div  class="linkContent">
            <div  class="linkTitle" style="margin-bottom: 10px">
                联系我们
                <div></div>
            </div>
            <div>
                <div style="display: flex">
                    <div style="width: 60px;height: 60px;background:#fff;text-align: center;box-sizing: border-box;margin-bottom:0"><img :src="require('@/assets/img/qrCode.jpg')" alt="" width="60"></div>
                    <div style="margin-left: 10px;padding-top:20px;margin-bottom:0">
                        <p>关注公众号</p>
                        <p>获取更多信息</p>
                    </div>
<!--                  <div style="width: 60px;height: 60px;background:#fff;text-align: center;box-sizing: border-box;margin-bottom:0"><img src="../assets/img/qrCode1.png" alt="" width="60"></div>-->
<!--                  <div style="margin-left: 10px;padding-top:20px;margin-bottom:0">-->
<!--                    <p>扫描售后工单</p>-->
<!--                    <p>填写问题描述</p>-->
<!--                  </div>-->
                </div>
                <div ><span>业务咨询: 021-60936903</span></div>
                <div ><span>市场/媒体: marketing@eternal-health.cn</span></div>
                <div ><span>售后服务: service@eternal-health.cn</span></div>
                <div><span>上海总部:上海市张衡路666弄1号楼</span></div>
               <div><span>&nbsp;</span></div>
            </div>
        </div>
      <div  class="linkContent">
        <div  class="linkTitle" style="margin-bottom: 10px">
          留言板
          <div></div>
        </div>
        <div>
          <div>
            <p style="white-space: nowrap;margin-bottom: 12px">扫码填写问卷或<span style="color: #409EFF!important;cursor: pointer" @click="writeQue">点击这里在线填写</span></p>
            <div style="width: 120px;height: 120px;background:#fff;text-align: center;box-sizing: border-box;margin-bottom:0"><img :src="require('@/assets/img/queQrCode.png')" alt="" width="120"></div>
            <p style="margin-top: 12px">我们将第一时间安排专人与您对接</p>
            <p>感谢您的支持！</p>
          </div>
<!--          <div style="display: flex">-->
<!--            <div style="width: 60px;height: 60px;background:#fff;text-align: center;box-sizing: border-box;margin-bottom:0"><img :src="require('@/assets/img/queQrCode.png')" alt="" width="60"></div>-->
<!--            <div style="margin-left: 10px;padding-top:20px;margin-bottom:0">-->
<!--              <p>扫描二维码</p>-->
<!--              <p>填写留言</p>-->
<!--              <p> <a style="color: #409EFF!important;" @click="writeQue">在线填写</a></p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div > <el-link type="primary" @click="writeQue">填写问卷</el-link></div>-->
          <!--                <div><span>无锡分公司:江苏省无锡市滨湖区马山梅梁西路88号</span></div>-->
          <!--                <div><span>湖州研发中心:浙江省湖州市吴兴区红丰路1366号6D幢</span></div>-->
        </div>
      </div>
    </div>
    <div class="record" style="margin-top: 25px">
        <div>
            <div >网站地图/法律声明</div>
            <div >网站备案号:<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #005be4;padding-left: 10px">沪ICP备17032264号-1</a></div>
            <div >上海唐颐信息技术有限公司</div>
            <div >Shanghai Eternal Health Information Technology</div>
        </div>
    </div>
  </footer>
</template>

<script>
import WOW from '../../node_modules/wowjs/dist/wow';
export default {
    mounted() {
        // let wow = new WOW.WOW({
        //     boxClass: 'wow',
        //     animateClass: 'animated',
        //     offset: 0,
        //     mobile: true,
        //     live: true
        // });
        // wow.init();
    },
  methods:{
    writeQue(){
      window.open('https://wj.qq.com/s2/14999933/0f01/')
    }
  }
}
</script>

<style lang="less" scoped>
    footer{
        width: 100%;
        height: 400px;
        /*margin-top: 150px;*/
        background: #f4f4f4;
        .link{
            width: 1100px;
            height: 360px;
            margin: 0 auto;
            padding: 79px 10px 0;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            .linkContent{
                .linkTitle{
                    font-size: 15px;
                    text-transform: uppercase;
                    font-weight: bold;
                    letter-spacing: 1px;
                    margin-bottom: 47px;
                    div{
                        width: 60px;
                        height: 2px;
                        background: #000;
                        margin-top: 12px;
                    }
                }
                a{
                    display: flex;
                    width: auto;
                    font-size: 15px;
                    text-decoration: none;
                    cursor: pointer;
                    letter-spacing: 1px;
                    height: 23px;
                    margin-bottom: 22px;
                    box-sizing: border-box;
                    span{
                        display: inline-block;
                    }
                }
                a:hover{
                    span{
                        color: #ed363c;
                        border-bottom: 2px solid #f1a1a2;
                    }
                }
                div{
                    font-size: 15px;
                    text-decoration: none;
                    letter-spacing: 1px;
                    /*height: 23px;*/
                    margin-bottom: 20px;
                }
            }
        }
        .record{
            width: 100%;
            height: 40px;
            margin: 0 auto;
            box-sizing: border-box;
            background: #ed1d25;
            &>div{
                width: 1200px;
                height: 40px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                div{
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
    }

</style>
